import { useState, useEffect } from "react";

// Define types for image coordinates
interface ImageCoordinate {
  point: [number, number];
  label: string;
}

const useVijilize = () => {
  const [headerData, setHeaderData] = useState(() => {
    const storedData = localStorage.getItem("headerData");
    return storedData && storedData !== "undefined"
      ? JSON.parse(storedData)
      : {
          projectDetail: { title: "", description: "", id: "" },
          claimAnalysis: { title: "", id: "" },
          vijilize: { title: "", id: "" },
          claimChart: { title: "", id: "" },
          portfolioDetail: { title: "", description: "", id: "" },
        };
  });

  const [isActiveSection, setIsActiveSection] = useState(0);
  const [clickedHeatmapData, setClickedHeatmapData] = useState<any>(null);
  const [markdownContent, setMarkdownContent] = useState<any>(null);
  const [imageCoordinates, setImageCoordinates] = useState<ImageCoordinate[]>(
    []
  );
  const [originalImagePath, setOriginalImagePath] = useState<string>("");
  const [annotationS3Path, setAnnotationS3Path] = useState<string>("");
  const [markdownS3Path, setMarkdownS3Path] = useState<string>("");
  const [annotationData, setAnnotationData] = useState<any>(null);
  const [patentImage, setPatentImage] = useState<any>(null);
   const [fontInfo, setFontInfo] = useState<any>(null)

  useEffect(() => {
    localStorage.setItem("headerData", JSON.stringify(headerData));
  }, [headerData]);

  const setVijilizeParamsData = (data: any) => {
    localStorage.setItem("vijilizeParamsData", JSON.stringify(data));
  };

  const getVijilizeParamsData = () => {
    const data = localStorage.getItem("vijilizeParamsData");
    return data ? JSON.parse(data) : null;
  };

  const setHeaderDataLocal = (data: any) => {
    setHeaderData(data);
  };

  return {
    getVijilizeParamsData,
    setVijilizeParamsData,
    isActiveSection,
    setIsActiveSection,
    setHeaderDataLocal,
    headerData,
    clickedHeatmapData,
    setClickedHeatmapData,
    markdownContent,
    setMarkdownContent,
    imageCoordinates,
    setImageCoordinates,
    originalImagePath,
    setOriginalImagePath,
    annotationS3Path,
    setAnnotationS3Path,
    markdownS3Path,
    setMarkdownS3Path,
    annotationData,
    setAnnotationData,
    patentImage,
    setPatentImage,
    fontInfo,
    setFontInfo
  };
};

export default useVijilize;
